import type { ReactNode } from 'react';

interface DetailColumnsProps {
  /** Primary content — the entity's own data (details, line items, etc.). */
  main: ReactNode;
  /** Secondary panels — activity, notes/comments, attachments, audit. Rendered
   *  in a right sidebar on large screens; stacks under `main` on small ones. */
  aside: ReactNode;
}

/** Two-column detail body that puts the wasted right-hand space to work.
 *  The page header + any page-level banners stay full-width above this. */
export function DetailColumns({ main, aside }: DetailColumnsProps) {
  return (
    <div className="grid gap-6 lg:grid-cols-5">
      <div className="space-y-6 lg:col-span-3">{main}</div>
      <aside className="space-y-6 lg:col-span-2">{aside}</aside>
    </div>
  );
}
